module.exports = __webpack_public_path__ + "media/images/calendar-6984250b9d8ed8cf340fd00c0c2ebcfb.png";